<template>
	<form v-bind="$attrs" v-on="$listeners" class="form--tabbed">
		<v-tabs
			ref="tabs"
			:class="tabsClass"
			:nav-class="navClass"
			:tab-classes="tabClasses"
			:tabless="tabless"
			:update-hash="updateHash"
			v-slot="{ previous, next, goToPrevious, goToNext, goToTab, nextIs }"
			v-on:selectedTabChanged="(payload) => $emit('selectedTabChanged', payload)"
			v-on:tabsChanged="(payload) => $emit('tabsChanged', payload)">
			<slot
				:previous="previous"
				:next="next"
				:goToPrevious="goToPrevious"
				:goToNext="goToNext"
				:goToTab="goToTab"
				:nextIs="nextIs"
			/>
		</v-tabs>
	</form>
</template>
<script>
export default {
	data() {
		return {
			tabClasses: {},
			observer: null
		};
	},
	props: {
		tabsClass: {
			type: String,
			required: false
		},
		navClass: {
			type: String,
			required: false
		},
		tabless: {
			type: Boolean,
			required: false,
			default: false
		},
		updateHash: {
			type: Boolean,
			required: false,
			default() {
				return false;
			}
		}
	},
	methods: {
		tabClass(tab) {
			let errors = tab.$el.querySelectorAll(".error-block").length;
			return {
				"error-tab": !!errors
			};
		},
		onMutation() {
			let tabClasses = {};
			_.each(
				this.$refs.tabs.tabs,
				function (tab) {
					tabClasses[tab.id] = this.tabClass(tab);
				}.bind(this)
			);
			this.tabClasses = tabClasses;
		},
		initMutationObserver() {
			this.observer = new MutationObserver(this.onMutation);
			this.observer.observe(this.$el, {
				childList: true,
				subtree: true
			});
		}
	},
	mounted() {
		this.initMutationObserver();
	},
	beforeDestroy() {
		this.observer.disconnect();
		this.observer = null;
	}
};
</script>
